import CryptoJS from 'crypto-js'

const KEY = CryptoJS.enc.Utf8.parse('LOGINAESKEYMES45')
const IV = CryptoJS.enc.Utf8.parse('LOGINAESIV123456')
// 解密方法
export const Decrypt = (word) => {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    let decrypt = CryptoJS.AES.decrypt(srcs, KEY,
        {iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
}

// 加密方法
export const Encrypt = (word) => {
    let srcs = CryptoJS.enc.Utf8.parse(word)
    let encrypted = CryptoJS.AES.encrypt(srcs, KEY,
        {iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})
    return encrypted.ciphertext.toString().toUpperCase()
}

export const TENANT_KEY = 'emis-tenant'
export const CURRENT_ORG_KEY = 'emis-curOrg'
export const CURRENT_ORG_CODE_KEY = 'emis-curOrg-code'
export const USER_INFO_KEY = 'emis-userInfo'
/**
 * 获取顶部地址栏地址
 */
export const getTopUrl = () => {
    return window.location.href.split('/#/')[0]
}
export default {
    Decrypt,
    Encrypt
}



// WEBPACK FOOTER //
// ./src/components/login/secret.js